import { Self, Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { AppTools } from '../utils/tools';

@Directive({
  selector: 'input[toTitleCase]',
})
export class InputTitlecaseDirective {
  constructor(@Self() private input: NgControl) {}

  @HostListener('input', ['$event']) onInput($event: any) {
    $event.preventDefault();
    const target = $event.target as HTMLInputElement;
    this.input?.control?.setValue(
      AppTools.capitalizeFirstLetterOfEachWord(target.value)
    );
  }
}
